import { render, staticRenderFns } from "./ProfileEditAvatar.vue?vue&type=template&id=79453d0e&scoped=true"
import script from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditAvatar.vue?vue&type=style&index=0&id=79453d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79453d0e",
  null
  
)

export default component.exports